// extracted by mini-css-extract-plugin
export default {"faqItem":"styles_faqItem__YbJ2i","question":"styles_question__cwuyv","arrow":"styles_arrow__z-3Wk","open":"styles_open__cgGFt","answer":"styles_answer__D2NvG"};